import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cert-progress-header',
  templateUrl: './cert-progress-header.component.html',
  styleUrls: ['./cert-progress-header.component.scss']
})
export class CertProgressHeaderComponent {
  @Input() certPercent: number = 62;
  @Input() hoursToCheckride: number = 14;
}
